import { render, staticRenderFns } from "./ProductFormWrapper.vue?vue&type=template&id=8b583cb8&scoped=true&"
import script from "./ProductFormWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductFormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b583cb8",
  null
  
)

export default component.exports